module.exports = __webpack_public_path__ + "img/logo7.d52e8183.png";